/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.multistream.defs";

export { $nsid };

type TargetView = { $type?: "place.stream.multistream.defs#targetView";"uri":l.AtUriString;"cid":l.CidString;"record":l.LexMap;"latestEvent"?:Event };

export type { TargetView };

const targetView = /*#__PURE__*/ l.typedObject<TargetView>($nsid, "targetView", /*#__PURE__*/ l.object({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"cid":/*#__PURE__*/ l.string({"format":"cid"}),"record":/*#__PURE__*/ l.lexMap(),"latestEvent":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<Event>((() => event) as any))}));

export { targetView };

type Event = { $type?: "place.stream.multistream.defs#event";"message":string;"status":"inactive" | "pending" | "active" | "error";"createdAt":l.DatetimeString };

export type { Event };

const event = /*#__PURE__*/ l.typedObject<Event>($nsid, "event", /*#__PURE__*/ l.object({"message":/*#__PURE__*/ l.string(),"status":/*#__PURE__*/ l.enum(["inactive","pending","active","error"]),"createdAt":/*#__PURE__*/ l.string({"format":"datetime"})}));

export { event };
